module.exports = __webpack_public_path__ + "img/MLB.5abc2573.png";